import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Row, Col, Tab, Nav,
} from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import useTimeSlots from 'components/Common/Coaches/Hooks/useTimeSlots';

import TimeSlots from './TimeSlots';

export default function Availability({ coach }) {
  const timeSlots = useTimeSlots(coach.id);
  const [activeTabId, setActiveTabId] = useState();

  useEffect(() => {
    if (activeTabId) {
      const tab = document.getElementById(activeTabId);
      const container = tab.querySelector('.time-slots');
      const btnMoveRight = tab.querySelector('.btn-move-right');

      if ((container.scrollWidth - (container.scrollLeft + container.offsetWidth)) <= 1) {
        btnMoveRight.disabled = true;
        btnMoveRight.querySelector('.chevron-icon').classList.add('bg-gray-600');
      } else {
        btnMoveRight.disabled = false;
        btnMoveRight.querySelector('.chevron-icon').classList.remove('bg-gray-600');
      }
    }
  }, [activeTabId]);

  if (timeSlots === null) {
    return (
      <div className="mb-5">
        <Row>
          <Col>
            <h4 className="mb-3 fw-semibold">The next available session dates</h4>
          </Col>
        </Row>

        <Row>
          <Col>
            <LoadingPlaceholder text="Loading..." />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="mb-5">
      <Row>
        <Col>
          <h4 className="mb-3 fw-semibold">The next available session dates</h4>
        </Col>
      </Row>

      {Object.keys(timeSlots.slots).length > 0 ? (
        <Row>
          <Col>
            <Tab.Container
              id={`coach-${coach.id}-time-slots`}
              defaultActiveKey={Object.keys(timeSlots.slots)[0]}
            >
              <>
                <Nav className="justify-content-center">
                  {Object.keys(timeSlots.slots).map((timeSlotKey) => {
                    // const date = new Date(timeSlots.slots[timeSlotKey][0].start);
                    const firstSlot = timeSlots.slots[timeSlotKey][0];

                    return (
                      <Nav.Item key={timeSlotKey}>
                        <Nav.Link
                          eventKey={timeSlotKey}
                          className="time-slot me-2 mb-2 py-3 px-4 text-center border rounded"
                          onClick={() => setActiveTabId(`coach-${coach.id}-time-slots-tabpane-${timeSlotKey}`)}
                        >
                          <small>
                            {firstSlot.month_name}
                          </small>
                          <br />

                          <span className="fs-1">
                            {firstSlot.day}
                          </span>
                          <br />

                          <small>
                            {firstSlot.day_of_week}
                          </small>
                          <br />

                          <span className="d-inline-block mt-2 fw-semibold">
                            {timeSlots.slots[timeSlotKey].length}
                            &nbsp;
                            {timeSlots.slots[timeSlotKey].length === 1 ? 'slot' : 'slots'}
                          </span>
                        </Nav.Link>
                      </Nav.Item>
                    );
                  })}
                </Nav>

                <Tab.Content>
                  {Object.keys(timeSlots.slots).map((timeSlotKey) => (
                    <Tab.Pane key={timeSlotKey} eventKey={timeSlotKey}>
                      <TimeSlots
                        timeSlots={timeSlots.slots[timeSlotKey]}
                        tabId={`coach-${coach.id}-time-slots-tabpane-${timeSlotKey}`}
                      />
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </>
            </Tab.Container>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col>
            <p>No available time slots.</p>
          </Col>
        </Row>
      )}
    </div>
  );
}

Availability.propTypes = {
  coach: PropTypes.object.isRequired,
};
